import { createSelector } from 'reselect';
import { getViewportData } from './clusters';

export const getLabels = state => state.map.labelGrid;

export const getLabeledPolygonData = createSelector(
  [getViewportData],
  (viewportData) => Object.values(viewportData).filter(data => data.uiStyle && data.uiStyle.polygonLabel)
);
